import { ClientFieldSpecBase } from "abweb/dto/generated/ds/ClientFieldSpecBase";
export class ClientFieldSpec extends ClientFieldSpecBase {
  static createClientFieldSpec(fieldPath, operation) {
    const retVal = new ClientFieldSpec();
    retVal.initClientFieldSpec(fieldPath, operation);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=ClientFieldSpec.js.map
